import { Region } from '@compumark/order-management-client';

export function regionKeyCreator(params: { value: unknown }): string {
  const { value } = params;

  if (value && typeof value === 'object' && 'label' in (value as Region)) {
    const region = value as Region;
    const label = (region.label ?? '').trim();
    return label === '' ? '' : `${label}${region.limited ? ' (Limited)' : ''}`;
  }

  if (typeof value === 'string') {
    return value.trim();
  }

  return '';
}

export function regionsFilterValueGetter(params: {
  data?: { regions?: unknown };
}): Region[] {
  const regions = params.data?.regions;

  return Array.isArray(regions)
    ? (regions as Region[]).filter(
        (region) => (region?.label ?? '').trim() !== '',
      )
    : [];
}

export function regionSetFilterValueFormatter(params: {
  value: Region | null;
}): string | null {
  const region = params.value;

  return region
    ? `${region.label ?? ''}${region.limited ? ' (Limited)' : ''}`
    : null;
}

export function formatClasses(params: any): any {
  const input = params?.value;

  if (input === undefined || input === null || input === '') {
    return '';
  }

  const list = Array.isArray(input)
    ? input
    : typeof input === 'string'
    ? input
        .split(',')
        .map((entry) => entry.trim())
        .filter((entry) => entry !== '')
    : [input];

  const values = list
    .flatMap((entry: any) => {
      if (typeof entry === 'string') {
        if (entry.includes('-')) {
          const [start, end] = entry
            .split('-')
            .map((part) => Number(part.trim()));
          if (!Number.isNaN(start) && !Number.isNaN(end)) {
            const range: number[] = [];
            for (let current = start; current <= end; current++) {
              range.push(current);
            }
            return range;
          }
        }

        const number = Number(entry);
        return Number.isNaN(number) ? [] : [number];
      }

      return Number.isFinite(Number(entry)) ? [Number(entry)] : [];
    })
    .sort((a, b) => a - b);

  if (values.length === 0) {
    return '';
  }

  const ranges: string[] = [];
  let start = values[0];
  let end = values[0];

  for (let index = 1; index < values.length; index++) {
    const current = values[index];
    if (current === end + 1) {
      end = current;
      continue;
    }

    ranges.push(start === end ? String(start) : `${start}-${end}`);
    start = current;
    end = current;
  }

  ranges.push(start === end ? String(start) : `${start}-${end}`);
  return ranges.join(', ');
}

export function formatClassesFilterValue(params: { value: unknown }): string {
  const { value } = params;

  if (value === undefined || value === null) {
    return '';
  }

  if (Array.isArray(value)) {
    return value
      .map((entry) => String(entry).trim())
      .filter((entry) => entry !== '')
      .join(', ');
  }

  return typeof value === 'string' ? value.trim() : String(value);
}

export function assigneeKeyCreatorAndValueFormatter(params: any): string {
  return params.value ? params.value.toLowerCase().trim() : 'unassigned';
}

export const assigneeKeyCreator = assigneeKeyCreatorAndValueFormatter;
